import { observer } from 'mobx-react';
import React from 'react';

const LtlRateBadge = ({ data: { extra } }) => {
	if (!extra || !extra.isLtl) return null;
	return <i className="icon icon--med icon--ltl spc--right--tny" />;
};

export default observer(LtlRateBadge);
